/**
 * Created by Mikhail Menshenin on 20.08.2024
 */

cleverapps.overrideStyles(cleverapps.styles.UI.Avatar, {
    x: 6,
    top: 6,
    bottom: 12
});

ScaledProgressBar.Types = cleverapps.overrideTemplates(ScaledProgressBar.Types, {
    golden: {
        progress: bundles.progress_bar.frames.bar_green_large,
        background: bundles.progress_bar.frames.bg_golden
    }
});
